import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import uuidv4 from 'uuid/v4';
import './styles.scss';
import { resolveLocalizedText, getValidToken, isApp } from '../../../../utils';
import ListItemUnderline from '../../components/ListItemUnderline';
import {
  getOffersFormConfig,
  getOffersFormData,
} from '../../selectors/offersSelector';
import { t } from '../../../../locales';
import EditBlue from '../../../../assets/images/edit-blue@3x.png';
import { goto, hideBackButton } from '../../../../actions/historyActions';
import { putCustState } from '../../../../actions/userActions';
import {
  commitOffers,
  updateReviewLoading,
} from '../../actions/offersFormAction';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import BackNavButton from '../../components/BackNavButton';
import env from '../../../../env';
import i18next from 'i18next';
import browserHistory from '../../../../stores/browserHistory';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../utils/generalGaEventAnalytics';
import { getLanguage } from '../../../../selectors/userSelectors';
import { getIsPromotionChecked } from '../../selectors/offersSelector';
import { trackSubmitLeadForm } from '../../../../utils/firebaseAnalyticsEvents';

interface OffersFormReviewContainerProps {
  offersFormConfig: any;
  offersInfoConfig: any;
  formDependentConfig: any;
  offersDependentConfig: any;
  offersData: any;
  loadingFlag: boolean;
  commitOffers: (value: any, callback?: () => void) => void;
  onHideBackButton: () => void;
  updateReviewLoading: (loadingFlag: any) => void;
  primaryCampaignSource: string;
  isPromotionChecked: boolean;
}

export class OffersFormReviewContainer extends Component<OffersFormReviewContainerProps> {
  constructor(props: any = {}) {
    super(props);

    this.goBackToForm = this.goBackToForm.bind(this);
    this.confirmOfferForm = this.confirmOfferForm.bind(this);
  }

  componentDidMount() {
    // this.props.onHideBackButton();
    const {
      infoObj: { name },
    } = this.props.offersData;
    !name && this.goBackToForm();
  }

  formatBrithdayForShow(birthday: string) {
    const brithdayForShow = birthday
      ? moment(birthday).format('YYYY/MM/DD')
      : '';
    return brithdayForShow;
  }

  goBackToForm() {
    browserHistory.goBack();
  }

  buildRemarkStrByOneDependency(
    index: number,
    relationship: string,
    fullName: string,
    gender: string,
    dob: string,
  ): string {
    return `Immediate Family Member Information ${index}:\nRelationship:${relationship}\nFull Name:${fullName}\nGender:${gender}\nDate of Birth:${moment(
      dob,
    ).format('DD/MM/YYYY')}\n\n`;
  }

  buildRemarkStr(dependentArr: any[]) {
    let remark = '';
    if (dependentArr && dependentArr.length > 0) {
      dependentArr.forEach((ele: any, index: number) => {
        remark += this.buildRemarkStrByOneDependency(
          index + 1,
          this.parseRelationship(ele.relationship),
          ele.fullName,
          this.parseGender(ele.gender),
          ele.birthday,
        );
      });
    }
    return remark;
  }

  parseRelationship(relationship: string): string {
    const zh = i18next.getFixedT('zh');
    const en = i18next.getFixedT('en');
    const spouseVal = `${en('RELATIONSHIP_SPOUSE_OPTION')},${zh(
      'RELATIONSHIP_SPOUSE_OPTION',
    )}`;
    const childVal = `${en('RELATIONSHIP_CHILD_OPTION')},${zh(
      'RELATIONSHIP_CHILD_OPTION',
    )}`;
    const parentVal = `${en('RELATIONSHIP_PARENT_OPTION')},${zh(
      'RELATIONSHIP_PARENT_OPTION',
    )}`;
    const parentInLawVal = `${en('RELATIONSHIP_PARENT_IN_LAW_OPTION')},${zh(
      'RELATIONSHIP_PARENT_IN_LAW_OPTION',
    )}`;
    return t('RELATIONSHIP_PARENT_IN_LAW_OPTION') === relationship
      ? parentInLawVal
      : t('RELATIONSHIP_PARENT_OPTION') === relationship
      ? parentVal
      : t('RELATIONSHIP_SPOUSE_OPTION') === relationship
      ? spouseVal
      : childVal;
  }

  // parseGender(gender: string): string {
  //   const zh = i18next.getFixedT('zh');
  //   const en = i18next.getFixedT('en');
  //   const maleVal = `${en('GENDER_MALE_OPTION')},${zh('GENDER_MALE_OPTION')}`;
  //   const femaleVal = `${en('GENDER_FEMALE_OPTION')},${zh('GENDER_FEMALE_OPTION')}`;
  //   return t('GENDER_MALE_OPTION') === gender ? maleVal : femaleVal;
  // }

  parseGender(gender: string): string {
    return t('GENDER_MALE_OPTION') === gender ? 'Male' : 'Female';
  }

  confirmOfferForm() {
    const transactionId = uuidv4();
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    const screenName = getGaPagePath();
    const leadSource = 'freePA';
    const leadProduct = 'offers';
    const { gaClientId, gaTrackId } = this.props.offersData;
    const { isPromotionChecked } = this.props;
    try {
      // GA3
      tcWindow.dataLayer.push({
        event: 'SubmitMyPolicyLeadForm',
        screenName: screenName,
        leadType: 'unspeclead',
        leadProduct: leadProduct,
        leadSource: leadSource,
        leadId: transactionId,
        userId: aToken,
      });

      // GA4
      trackSubmitLeadForm(
        screenName,
        'unspeclead',
        leadProduct,
        leadSource,
        transactionId,
      );

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.SubmitMyPolicyLeadForm(tcWindow, {
      //     screenName: screenName,
      //     leadType: 'unspeclead',
      //     leadProduct: leadProduct,
      //     leadSource: leadSource,
      //     leadId: transactionId,
      //     AXAID: aToken,
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
    this.props.updateReviewLoading(true);
    const { primaryCampaignSource } = this.props.offersFormConfig;
    const {
      infoObj: {
        name,
        gender,
        birthday,
        email,
        mobileCountryCode,
        mobile,
        consultantMobileCountryCode,
        consultantMobile,
        product,
        promotionCode,
        agentCode,
      },
      dependentArr,
    } = this.props.offersData;
    const lang = getLanguage();
    const submitValues = {
      transactionid: transactionId, // note that transactionid field name is lowercase
      // isipro: true,
      iscustomer: '1',
      gender: this.parseGender(gender),
      vacainnationDob: moment(birthday).format('YYYY-MM-DD'),
      name: name,
      // lastName: name,
      // prefix: mobileCountryCode,
      telephone: `${mobileCountryCode}${mobile}`,
      // agentMobileNumber: `${consultantMobileCountryCode}${consultantMobile}`,
      email: email,
      // leadAutoConvert: '1',
      remarks: this.buildRemarkStr(dependentArr),
      primaryCampaignSource: `CAM-${primaryCampaignSource}`,
      leadSource: 'Emma',
      // campaign: `${leadProduct}-${leadSource}`,
      // leadChannel: 'HK_Emma',
      leadLevel: 'Silver',
      // GACLIENTID: gaClientId,
      // GATRACKID: gaTrackId,
      axaId: aToken,
      price: {},
      selectedPlansId: product,
      promoCode: promotionCode,
      dmConsent: isPromotionChecked ? 'True' : 'False',
      lang: lang === 'en' ? 'English' : 'Chinese (Traditional)',
      referralAgentCode: agentCode,
    };
    this.props.commitOffers(submitValues, () => {
      this.goBackToForm();
    });
  }

  render() {
    const { offersFormConfig, loadingFlag } = this.props;
    const {
      nameLabel,
      genderLabel,
      birthdayLabel,
      emailLabel,
      mobileLabel,
      consultantMobileLabel,
      productLabel,
      promotionCodeLabel,
      productOptions,
      agentCodeLabel,
    } = this.props.offersInfoConfig;
    const {
      dependentTitle,
      dependentrelationshipLabel,
      dependentnameLabel,
      dependentgenderLabel,
      dependentbirthdayLabel,
    } = this.props.formDependentConfig;
    const {
      infoObj: {
        name,
        gender,
        birthday,
        email,
        mobileCountryCode,
        mobile,
        consultantMobileCountryCode,
        consultantMobile,
        product,
        promotionCode,
        agentCode,
      },
      dependentArr,
    } = this.props.offersData;
    const checkIsApp = isApp();
    const lang = getLanguage();
    const productObj =
      productOptions.find((item: any) => item.optionVal[lang] === product) ||
      {};
    const productValue = productObj.optionTitle
      ? resolveLocalizedText(productObj.optionTitle)
      : '';

    // {!checkIsApp && <BackNavButton backPath="emma-free-offers" />}
    return (
      <div className="emma-stylesheet-grid-system offers-form-review-container">
        <div className="offers-form-review__title">
          {offersFormConfig.title}
        </div>
        <div className="offers-form-review__sub-title-container">
          <div className="offers-form-review__sub-title offers-form-review__sub-title--mb24">
            {t('REVIEW_INFORMATION')}
          </div>
          <div
            className="offers-form-review__sub-title-icon"
            style={{ backgroundImage: `url(${EditBlue})` }}
            onClick={this.goBackToForm}
            data-enable-ga
            data-ga-type="button"
          ></div>
        </div>
        {/* Your Information */}
        <div>
          <div className="offers-form-review__sub-title">
            {offersFormConfig.informationTitle}
          </div>
          <div className="offers-form-review__list">
            <ListItemUnderline
              id={
                nameLabel.indexOf('*') != -1
                  ? nameLabel.substring(
                      nameLabel.indexOf('*') + 1,
                      nameLabel.length,
                    )
                  : nameLabel
              }
              value={name ? name : ''}
            />
            <ListItemUnderline
              id={
                genderLabel.indexOf('*') != -1
                  ? genderLabel.substring(
                      genderLabel.indexOf('*') + 1,
                      genderLabel.length,
                    )
                  : genderLabel
              }
              value={gender ? gender : ''}
            />
            <ListItemUnderline
              id={
                birthdayLabel.indexOf('*') != -1
                  ? birthdayLabel.substring(
                      birthdayLabel.indexOf('*') + 1,
                      birthdayLabel.length,
                    )
                  : birthdayLabel
              }
              value={this.formatBrithdayForShow(birthday)}
            />
            <ListItemUnderline
              id={
                emailLabel.indexOf('*') != -1
                  ? emailLabel.substring(
                      emailLabel.indexOf('*') + 1,
                      emailLabel.length,
                    )
                  : emailLabel
              }
              value={email ? email : ''}
            />
            <ListItemUnderline
              id={
                mobileLabel.indexOf('*') != -1
                  ? mobileLabel.substring(
                      mobileLabel.indexOf('*') + 1,
                      mobileLabel.length,
                    )
                  : mobileLabel
              }
              value={
                mobileCountryCode && mobile
                  ? `(${mobileCountryCode}) ${mobile}`
                  : ''
              }
            />
            {consultantMobile && (
              <ListItemUnderline
                id={t('REVIEW_CONSULTANT_MOBILE_NO')}
                value={
                  consultantMobileCountryCode && consultantMobile
                    ? `(${consultantMobileCountryCode}) ${consultantMobile}`
                    : ''
                }
              />
            )}
            <ListItemUnderline
              id={
                productLabel.indexOf('*') != -1
                  ? productLabel.substring(
                      productLabel.indexOf('*') + 1,
                      productLabel.length,
                    )
                  : productLabel
              }
              value={productValue ? productValue : ''}
            />
            {promotionCode && (
              <ListItemUnderline
                id={promotionCodeLabel}
                value={promotionCode ? promotionCode : ''}
              />
            )}
            {agentCode && (
              <ListItemUnderline
                id={agentCodeLabel}
                value={agentCode ? agentCode : ''}
              />
            )}
          </div>
        </div>
        {/* Family member */}
        {dependentArr &&
          dependentArr.map((dep: any, index: any) => {
            return (
              <div key={index}>
                <div className="offers-form-review__sub-title">
                  {dependentTitle} {index + 1}
                </div>
                <div className="offers-form-review__list">
                  <ListItemUnderline
                    id={
                      dependentrelationshipLabel.indexOf('*') != -1
                        ? dependentrelationshipLabel.substring(
                            dependentrelationshipLabel.indexOf('*') + 1,
                            dependentrelationshipLabel.length,
                          )
                        : dependentrelationshipLabel
                    }
                    value={dep && dep.relationship ? dep.relationship : ''}
                  />
                  <ListItemUnderline
                    id={
                      dependentnameLabel.indexOf('*') != -1
                        ? dependentnameLabel.substring(
                            dependentnameLabel.indexOf('*') + 1,
                            dependentnameLabel.length,
                          )
                        : dependentnameLabel
                    }
                    value={dep && dep.fullName ? dep.fullName : ''}
                  />
                  <ListItemUnderline
                    id={
                      dependentgenderLabel.indexOf('*') != -1
                        ? dependentgenderLabel.substring(
                            dependentgenderLabel.indexOf('*') + 1,
                            dependentgenderLabel.length,
                          )
                        : dependentgenderLabel
                    }
                    value={dep && dep.gender ? dep.gender : ''}
                  />
                  <ListItemUnderline
                    id={
                      dependentbirthdayLabel.indexOf('*') != -1
                        ? dependentbirthdayLabel.substring(
                            dependentbirthdayLabel.indexOf('*') + 1,
                            dependentbirthdayLabel.length,
                          )
                        : dependentbirthdayLabel
                    }
                    value={
                      dep && dep.birthday
                        ? this.formatBrithdayForShow(dep.birthday)
                        : ''
                    }
                  />
                </div>
              </div>
            );
          })}
        <div className="offers-form__button">
          <button
            className={`emma-stylesheet-primary-secondary-default-button ${
              loadingFlag
                ? 'emma-stylesheet-left-default-loading-icon-button'
                : ''
            }`}
            disabled={loadingFlag}
            data-enable-ga={!loadingFlag}
            data-ga-type="button"
            onClick={loadingFlag ? () => {} : this.confirmOfferForm}
          >
            {t('CONFIRM')}
          </button>
        </div>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const { offersData, loadingFlag } = getOffersFormData(state);
    const offersFormConfig = getOffersFormConfig(state);
    const offersInfoConfig =
      offersFormConfig &&
      offersFormConfig.information &&
      offersFormConfig.information.form
        ? offersFormConfig.information.form
        : {};
    const formDependent =
      offersFormConfig && offersFormConfig.dependent
        ? offersFormConfig.dependent
        : {};
    const formDependentConfig =
      offersFormConfig &&
      offersFormConfig.dependent &&
      offersFormConfig.dependent.form
        ? offersFormConfig.dependent.form
        : {};
    const isPromotionChecked = getIsPromotionChecked(state) || false;
    return {
      offersFormConfig: {
        title:
          offersFormConfig && offersFormConfig.title
            ? resolveLocalizedText(offersFormConfig.title)
            : '',
        informationTitle:
          offersFormConfig &&
          offersFormConfig.information &&
          offersFormConfig.information.title
            ? resolveLocalizedText(offersFormConfig.information.title)
            : '',
        primaryCampaignSource:
          offersFormConfig && offersFormConfig.primaryCampaignSource
            ? offersFormConfig.primaryCampaignSource
            : '',
      },
      offersInfoConfig: {
        nameLabel:
          offersInfoConfig &&
          offersInfoConfig.name &&
          offersInfoConfig.name.label
            ? resolveLocalizedText(offersInfoConfig.name.label)
            : '',
        genderLabel:
          offersInfoConfig &&
          offersInfoConfig.gender &&
          offersInfoConfig.gender.label
            ? resolveLocalizedText(offersInfoConfig.gender.label)
            : '',
        birthdayLabel:
          offersInfoConfig &&
          offersInfoConfig.birthday &&
          offersInfoConfig.birthday.label
            ? resolveLocalizedText(offersInfoConfig.birthday.label)
            : '',
        emailLabel:
          offersInfoConfig &&
          offersInfoConfig.email &&
          offersInfoConfig.email.label
            ? resolveLocalizedText(offersInfoConfig.email.label)
            : '',
        mobileLabel:
          offersInfoConfig &&
          offersInfoConfig.mobile &&
          offersInfoConfig.mobile.label
            ? resolveLocalizedText(offersInfoConfig.mobile.label)
            : '',
        consultantMobileLabel:
          offersInfoConfig &&
          offersInfoConfig.consultantMobile &&
          offersInfoConfig.consultantMobile.label
            ? resolveLocalizedText(offersInfoConfig.consultantMobile.label)
            : '',
        productLabel:
          offersInfoConfig &&
          offersInfoConfig.product &&
          offersInfoConfig.product.label
            ? resolveLocalizedText(offersInfoConfig.product.label)
            : '',
        promotionCodeLabel:
          offersInfoConfig &&
          offersInfoConfig.promotionCode &&
          offersInfoConfig.promotionCode.mandatoryLabel
            ? resolveLocalizedText(
                offersInfoConfig.promotionCode.mandatoryLabel,
              )
            : '',
        productOptions:
          offersInfoConfig &&
          offersInfoConfig.product &&
          offersInfoConfig.product.options
            ? offersInfoConfig.product.options
            : [],
        agentCodeLabel:
          offersInfoConfig &&
          offersInfoConfig.agentCode &&
          offersInfoConfig.agentCode.label
            ? resolveLocalizedText(offersInfoConfig.agentCode.label)
            : '',
      },
      formDependentConfig: {
        dependentTitle:
          formDependent && formDependent.formTitle
            ? resolveLocalizedText(formDependent.formTitle)
            : '',
        dependentrelationshipLabel:
          formDependentConfig.relationship &&
          formDependentConfig.relationship.label
            ? resolveLocalizedText(formDependentConfig.relationship.label)
            : '',
        dependentnameLabel:
          formDependentConfig.name && formDependentConfig.name.label
            ? resolveLocalizedText(formDependentConfig.name.label)
            : '',
        dependentgenderLabel:
          formDependentConfig.gender && formDependentConfig.gender.label
            ? resolveLocalizedText(formDependentConfig.gender.label)
            : '',
        dependentbirthdayLabel:
          formDependentConfig.birthday && formDependentConfig.birthday.label
            ? resolveLocalizedText(formDependentConfig.birthday.label)
            : '',
      },
      offersData: offersData,
      loadingFlag: loadingFlag,
      isPromotionChecked,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      commitOffers: (value: any, callback?: () => void) =>
        dispatch(commitOffers(value, callback)),
      onHideBackButton: () => dispatch(hideBackButton()),
      updateReviewLoading: (loadingFlag: boolean) =>
        dispatch(updateReviewLoading(loadingFlag)),
    };
  }
}

export default connect(
  OffersFormReviewContainer.mapStateToProps,
  OffersFormReviewContainer.mapDispatchToProps,
)(OffersFormReviewContainer);
